import countryList from './countries';

const url = process.env.REACT_APP_API_URL || 'https://api.simpolium.com';

export { url, countryList };
